'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var moment = _interopDefault(require('moment-timezone'));

var formatUnconfirmedKeys = function (unconfirmedDays) {
    return Object.keys(unconfirmedDays).reduce(function (acc, date) {
        var day = moment(date).format('ddd-D');
        acc[day] = unconfirmedDays[date];
        return acc;
    }, {});
};
var getDaysThisWeek = function (day) {
    var tempDay = day.day();
    var result = [moment(day.weekday(0))];
    for (var i = 1; i < 7; i += 1) {
        result.push(moment(day.weekday(i)));
    }
    day.weekday(tempDay);
    return result;
};

exports.formatUnconfirmedKeys = formatUnconfirmedKeys;
exports.getDaysThisWeek = getDaysThisWeek;
